export default __webpack_public_path__ + "static/media/fancyNovel-android.eb1d3b3e.png";